import { useContext } from 'react';
import InputConfig from '../../../../Components/InputConfig';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import PageHeading from '../../../../Components/PageHeading';

import useCommonStyles from '../../../../commonStyles';
import { Grid, Paper } from '@mui/material';
import { ConfigContext } from '../../../../Contexts/ConfigContext';

/**
 * Helper Function to generate key data for Ad Requests Rheostat feature configuration
 * @param {string} keyData - The base key data for the feature configuration
 * @returns {{enabledKey: string, requestThresholdKey: string, delayPercentageKey: string}} An object containing the keys for the Ad Requests Rheostat feature configuration
 */
const getAdRequestsRheostatConfigKeys = (keyData) => {
	return {
		enabledKey: `${keyData}.enabled`,
		requestThresholdKey: `${keyData}.requestThreshold`,
		delayPercentageKey: `${keyData}.delayPercentage`
	};
};

/**
 * Body Component for Ad Requests Rheostat feature configuration
 * @component
 * @param {string} keyData - The base key data for the feature configuration
 * @returns {JSX.Element} The Ad Requests Rheostat feature configuration component
 */
const AdRequestsRheostatConfigBody = ({ keyData }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const { enabledKey, requestThresholdKey, delayPercentageKey } =
		getAdRequestsRheostatConfigKeys(keyData);

	return (
		<>
			<Grid container spacing={1} style={{ marginLeft: '5rem', width: '90%' }}>
				<Grid item xs={2} style={{ marginTop: '4.5rem' }}>
					<CheckBoxInput
						keyData={enabledKey}
						label="Enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
			<Grid container spacing={2} style={{ marginTop: '1rem', marginLeft: '4rem', width: '90%' }}>
				<Grid item xs={3}>
					<InputConfig
						label="Request Threshold"
						keyData={requestThresholdKey}
						editable={!!rawConfig[enabledKey]}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						label="Delay Percentage"
						keyData={delayPercentageKey}
						editable={!!rawConfig[enabledKey]}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</>
	);
};

/**
 * Main Container for Ad Requests Rheostat feature configuration
 * @component
 * @param {string} keyData - The base key data for the feature configuration
 * @param {string} featureDescription - The description of the feature to be displayed in the info button
 * @returns {JSX.Element} The Ad Requests Rheostat feature configuration component
 */
const AdRequestsRheostatConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Ad Requests Rheostat"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Ad Requests Rheostat']}
				description="Adds an additional delay to ad requests based on threshold and delay percentage values to reduce the number of ad requests."
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<AdRequestsRheostatConfigBody keyData={keyData} />
		</Paper>
	);
};
export default AdRequestsRheostatConfig;
